export default __webpack_public_path__ + "static/media/BK.cf4ca61f.png";